import { render, staticRenderFns } from "./TheUpsertDiscountProfile.vue?vue&type=template&id=15c3cf0c"
import script from "./TheUpsertDiscountProfile.vue?vue&type=script&lang=ts"
export * from "./TheUpsertDiscountProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports